if (!customElements.get('how-it-works-steps')) {
  class StepsSection extends HTMLElement {
    constructor() {
      super();

      this.heading = this.querySelector('[data-steps-reveal="heading"]');
      this.headings = this.querySelectorAll('[data-steps-reveal="heading"]');
      this.row = this.querySelector('[data-steps-row]');

      this.prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.handleIntersect = this.handleIntersect.bind(this);
    }

    connectedCallback() {
      const targets = [...this.headings, this.row].filter(Boolean);

      if (!targets.length) return;

      if (this.prefersReducedMotion || !('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-visible'));
        return;
      }

      this.observer = new IntersectionObserver(this.handleIntersect, {
        threshold: 0.2,
      });

      targets.forEach((el) => this.observer.observe(el));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        this.observer.unobserve(entry.target);
      });
    }
  }

  customElements.define('how-it-works-steps', StepsSection);
}